export default __webpack_public_path__ + "icon-madfit@2x.bc98e81d.png";